import { useMemo } from "react";
import {
  APILoadingStatus,
  useApiLoadingStatus,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";

/**
 * The legacy Places services, once the places library has loaded, or null
 * before then. `failed` is true when the Maps API could not load, so callers
 * keep manual entry available instead of waiting.
 */
export const usePlacesServices = () => {
  const places = useMapsLibrary("places");
  const status = useApiLoadingStatus();

  // PlacesService only needs a node to render attributions into, and the
  // fields never show any, so a detached element is enough.
  const services = useMemo(
    () =>
      places && {
        autocomplete: new places.AutocompleteService(),
        details: new places.PlacesService(document.createElement("div")),
        statusOk: places.PlacesServiceStatus.OK,
      },
    [places]
  );

  const failed =
    status === APILoadingStatus.FAILED ||
    status === APILoadingStatus.AUTH_FAILURE;

  return { services, failed };
};
